import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, ApiError } from "../api";
import { useT } from "../i18n";
import { docTitle } from "../components/ClauseReader";
import type { DocumentMeta } from "../types";

export default function LettersList() {
  const { t, lang } = useT();
  const [docs, setDocs] = useState<DocumentMeta[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<DocumentMeta[]>("/api/documents")
      .then((all) => setDocs(all.filter((d) => d.category === "letter")))
      .catch((e: ApiError) => setError(e.message));
  }, []);

  return (
    <div className="page">
      <header className="app-header">
        <h1 className="app-title">✉️ {t("letters.title")}</h1>
        <p className="app-sub">{t("letters.subtitle")}</p>
      </header>

      {!docs && !error && (
        <div className="empty">
          <span className="spinner" />
        </div>
      )}
      {error && <div className="alert error">{error}</div>}
      {docs && docs.length === 0 && <div className="empty">{t("letters.empty")}</div>}

      <div className="doc-list">
        {docs?.map((d) => (
          <Link key={d.slug} to={`/doc/${d.slug}`} className="doc-card">
            <div className="doc-card-main">
              <div className="doc-card-title">{docTitle(d, lang)}</div>
              {(d.doc_date || d.added_date) && (
                <div className="doc-card-dates">
                  {d.doc_date && (
                    <span className="date-chip">
                      ✉️ {t("letters.doc_date")}: {d.doc_date}
                    </span>
                  )}
                  {d.added_date && (
                    <span className="date-chip">
                      ➕ {t("letters.added")}: {d.added_date}
                    </span>
                  )}
                </div>
              )}
              <div className="doc-card-meta">
                {t("docs.count", { n: d.clause_count })} · {d.page_count} {t("docs.pages")}
              </div>
            </div>
            <span className="doc-card-arrow">›</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
